const CAMERA_WITH_TORCH_STORAGE_KEY = 'cameraWithTorchId';

/**
 * Verify if a camera with given ID still exists and has torch support
 */
// const verifyCameraWithTorch = async (cameraId: string): Promise<boolean> => {
//   try {
//     const testStream = await navigator.mediaDevices.getUserMedia({
//       video: { deviceId: { exact: cameraId } },
//     });

//     const videoTrack = testStream.getVideoTracks()[0];
//     const capabilities = videoTrack.getCapabilities() as MediaTrackCapabilities & {
//       torch?: boolean;
//     };

//     // Stop test stream immediately
//     testStream.getTracks().forEach((track) => track.stop());

//     return !!capabilities.torch;
//   } catch (err) {
//     console.log('Saved camera no longer available or has no torch:', err);
//     return false;
//   }
// };

/**
 * Find a camera with torch/flash support
 * First checks sessionStorage for previously found camera with torch.
 * If not found or no longer valid, tests each available camera and saves the result.
 * @returns Promise<string | null> - Device ID of the camera or null if no cameras found
 */
export const findCameraWithTorch = async (): Promise<string | null> => {
  try {
    // Check if we have a saved camera ID in sessionStorage
    const savedCameraId = sessionStorage.getItem(CAMERA_WITH_TORCH_STORAGE_KEY);

    if (savedCameraId) {
      console.log(`Found saved camera ID in sessionStorage: ${savedCameraId}`);

      return savedCameraId;
      // console.log('Verifying if saved camera is still available...');
      // const isValid = await verifyCameraWithTorch(savedCameraId);

      // if (isValid) {
      //   console.log('✓ Saved camera is still valid, using it!');
      //   return savedCameraId;
      // } else {
      //   console.log('Saved camera is no longer valid, searching for new one...');
      //   sessionStorage.removeItem(CAMERA_WITH_TORCH_STORAGE_KEY);
      // }
    }

    console.log('Searching for camera with torch support...');
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter((device) => device.kind === 'videoinput');

    if (videoDevices.length === 0) {
      console.log('No cameras found');
      return null;
    }

    // Test each camera for torch support
    for (const device of videoDevices) {
      try {
        console.log(`Testing camera: ${device.label || device.deviceId}`);
        const testStream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: { exact: device.deviceId } },
        });

        const videoTrack = testStream.getVideoTracks()[0];
        const capabilities = videoTrack.getCapabilities() as MediaTrackCapabilities & {
          torch?: boolean;
        };

        // Stop test stream immediately
        testStream.getTracks().forEach((track) => track.stop());

        if (capabilities.torch) {
          console.log(`✓ Found camera with torch: ${device.label || device.deviceId}`);
          // Save the camera ID to sessionStorage for future use
          sessionStorage.setItem(CAMERA_WITH_TORCH_STORAGE_KEY, device.deviceId);
          console.log('Saved camera ID to sessionStorage');
          return device.deviceId;
        } else {
          console.log(`✗ Camera without torch: ${device.label || device.deviceId}`);
        }
      } catch (err) {
        console.log(`Could not test camera: ${device.label || device.deviceId}`, err);
      }
    }

    // If no camera with torch found, return first available
    console.log('No camera with torch found, using first available camera');
    return videoDevices[0].deviceId;
  } catch (err) {
    console.error('Error finding camera:', err);
    return null;
  }
};
